function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import Spinner from '../../../atoms/Spinner';
import MobileMenuItemWithDropdown from './MobileMenuItemWithDropdown';
import MobileMenuHeader from './MobileMenuHeader';
import MobileMenuItem from './MobileMenuItem';
import HorizontalRule from '../../../atoms/HorizontalRule';
var KEY_ESC = 27;

var MobileMenuItemSection = function MobileMenuItemSection(_ref) {
  var menuLink = _ref.menuLink,
      onItemSelected = _ref.onItemSelected,
      LinkTemplate = _ref.LinkTemplate;
  return /*#__PURE__*/React.createElement("section", {
    id: "".concat(menuLink.heading && menuLink.heading.text, "-mobile-panel"),
    className: "menu__mobile-panel"
  }, menuLink.heading && menuLink.heading.url && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LinkTemplate, {
    onClick: onItemSelected,
    className: "menu__mobile-item link",
    url: menuLink.heading.url
  }, /*#__PURE__*/React.createElement("span", {
    className: "link__content"
  }, "Forside")), /*#__PURE__*/React.createElement(HorizontalRule, null)), menuLink.links.map(function (link, index) {
    if (link.subLinks) {
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: link.text
      }, /*#__PURE__*/React.createElement(MobileMenuItemWithDropdown, {
        index: index,
        link: link,
        onItemSelected: onItemSelected,
        LinkTemplate: LinkTemplate
      }), /*#__PURE__*/React.createElement(HorizontalRule, null));
    } else {
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: link.text
      }, /*#__PURE__*/React.createElement(MobileMenuItem, {
        index: index,
        link: link,
        onItemSelected: onItemSelected,
        LinkTemplate: LinkTemplate
      }), /*#__PURE__*/React.createElement(HorizontalRule, null));
    }
  }));
};

var MobileMenu = function MobileMenu(_ref2) {
  var isOpen = _ref2.isOpen,
      LinkTemplate = _ref2.LinkTemplate,
      onMobileMenuToggle = _ref2.onMobileMenuToggle,
      menuLinks = _ref2.menuLinks,
      onMenuItemSelected = _ref2.onMenuItemSelected,
      isLoading = _ref2.isLoading,
      mobileMenuCloseButtonLabel = _ref2.mobileMenuCloseButtonLabel;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      selectedHeaderIndex = _useState2[0],
      setSelectedHeaderIndex = _useState2[1];

  useEffect(function () {
    document.addEventListener('keydown', handleKeyDown);
    return function () {
      return document.removeEventListener('keydown', handleKeyDown);
    };
  });

  var handleKeyDown = function handleKeyDown(event) {
    if (event.keyCode === KEY_ESC) onMobileMenuToggle();
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "menu__overlay"
  }), /*#__PURE__*/React.createElement("div", {
    className: classnames('menu__mobile', {
      'menu__mobile--open': isOpen
    })
  }, /*#__PURE__*/React.createElement(MobileMenuHeader, {
    onMobileMenuToggle: onMobileMenuToggle,
    menuLinks: menuLinks,
    LinkTemplate: LinkTemplate,
    selectedIndex: selectedHeaderIndex,
    onHeaderItemSelected: function onHeaderItemSelected(index) {
      return setSelectedHeaderIndex(index);
    },
    mobileMenuCloseButtonLabel: mobileMenuCloseButtonLabel
  }), isLoading && /*#__PURE__*/React.createElement(Spinner, null), menuLinks && /*#__PURE__*/React.createElement(MobileMenuItemSection, {
    menuLink: menuLinks[selectedHeaderIndex],
    onItemSelected: onMenuItemSelected,
    LinkTemplate: LinkTemplate
  })));
};

MobileMenu.propTypes = {
  isOpen: PropTypes.bool,
  LinkTemplate: PropTypes.func,
  onMobileMenuToggle: PropTypes.func,
  menuLinks: PropTypes.arrayOf(PropTypes.shape({
    heading: PropTypes.shape({
      text: PropTypes.string,
      url: PropTypes.string
    }),
    links: PropTypes.arrayOf(PropTypes.shape({
      text: PropTypes.string,
      url: PropTypes.string
    }))
  })),
  onMenuItemSelected: PropTypes.func,
  isLoading: PropTypes.bool,
  mobileMenuCloseButtonLabel: PropTypes.string
};
export default MobileMenu;